import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  span {
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  hr {
    border: 1px solid ${({ theme }) => theme.colors.neutral.white};
    width: 100%;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Gallery = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;

  ${media.lessThan("medium")`
    grid-template-columns: 1fr;
  `}
`;

export const GalleryImage = styled.div`
  width: 100%;
  height: 200px;

  cursor: pointer;

  img {
    width: 100%;
    height: 200px;

    object-fit: cover;
  }

  :hover {
    opacity: 0.8;
  }
`;

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: center;

  ${media.lessThan("medium")`
    flex-direction: column;

    svg {
      display: none;
    }
  `}
`;

export const Image = styled.img`
  min-width: 700px;

  width: fit-content;
  height: fit-content;

  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;

  object-fit: cover;

  ${media.lessThan("medium")`
    min-width: 100vw;
    width: 100vw;
  `}
`;

export const MobileArrows = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  width: 100%;

  svg {
    display: block !important;
  }

  ${media.greaterThan("medium")`
    display: none;
  `}
`;

// --- Itens não-imagem do Álbum (B05, 03/09/2026) ---------------------------
// Mesma caixa de 200px da imagem, para a grade não ficar irregular.

export const GalleryVideo = styled.div`
  width: 100%;

  video {
    width: 100%;
    height: 200px;

    object-fit: cover;
    background-color: ${({ theme }) => theme.colors.neutral.black};
  }

  span {
    display: block;
    margin-top: 4px;

    font-size: 12px;
    word-break: break-word;
  }
`;

export const GalleryLink = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  width: 100%;
  height: 200px;
  padding: 12px;

  border: 1px solid ${({ theme }) => theme.colors.neutral.cinza600};

  color: ${({ theme }) => theme.colors.neutral.white};
  text-align: center;
  word-break: break-word;

  :hover {
    opacity: 0.8;
  }
`;
